import { render } from "./ScrollCenterDialog.vue?vue&type=template&id=1cab7868&scoped=true"
import script from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
export * from "./ScrollCenterDialog.vue?vue&type=script&lang=js"

import "./ScrollCenterDialog.vue?vue&type=style&index=0&id=1cab7868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cab7868"]])

export default __exports__